import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { IProject } from '../../models/project.interface';
import { environment } from '../../../environments/environment';

@Injectable()
export class ProjectService {
  url = `${environment.domain}/assets/data`;

  constructor(private _http: HttpClient) {}

  getProject(projectFolder: string): Observable<IProject> {
    const finalUrl = `${this.url}/${projectFolder}/info.json`;
    return this._http.get<IProject>(finalUrl);
  }
}
